import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function ActionTakenRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/action-taken', component: Index, isProtected: true, permissions: ['action_taken_index']},
    {path: '/action-taken/create', component: Create, isProtected: true, permissions: ['action_taken_create']},
    {path: '/action-taken/edit/:id', component: Edit, isProtected: true, permissions: ['action_taken_edit']},

  ];

  return routes;
}
